var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "yoyo-container mx-auto min-h-screen pb-[env(safe-area-inset-bottom)]",
    },
    [
      _c("navBar", { attrs: { title: _vm.$t("orders.title") } }),
      _c(
        "div",
        { staticClass: "mx-4 mt-4 space-y-3 pb-4" },
        [
          _vm.orders.length > 0
            ? _c(
                "van-pull-refresh",
                {
                  on: { refresh: _vm.onRefresh },
                  model: {
                    value: _vm.refreshing,
                    callback: function ($$v) {
                      _vm.refreshing = $$v
                    },
                    expression: "refreshing",
                  },
                },
                [
                  _c(
                    "van-list",
                    {
                      attrs: {
                        finished: _vm.finished,
                        "finished-text": _vm.$t("query.noMoreData"),
                        "loading-text": _vm.$t("query.loading"),
                      },
                      on: { load: _vm.onLoad },
                      model: {
                        value: _vm.loading,
                        callback: function ($$v) {
                          _vm.loading = $$v
                        },
                        expression: "loading",
                      },
                    },
                    _vm._l(_vm.orders, function (order, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass:
                            "bg-white rounded-xl px-3 py-2 shadow-sm mb-3",
                        },
                        [
                          _c(
                            "div",
                            {
                              class: [
                                "text-right text-sm font-bold mb-1",
                                _vm.getStatusClass(order.status),
                              ],
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.getStatusText(order.status)) +
                                  " "
                              ),
                            ]
                          ),
                          _vm._l(order.items, function (item, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass:
                                  "flex items-center border-b border-gray-100 py-2",
                                class:
                                  index === order.items.length - 1
                                    ? "border-b-0"
                                    : "",
                                on: {
                                  click: function ($event) {
                                    return _vm.viewOrderDetails(order)
                                  },
                                },
                              },
                              [
                                _c("img", {
                                  staticClass: "w-12 h-12 rounded-lg",
                                  attrs: {
                                    src: _vm.imageBaseUrl + item.picUrl,
                                    alt: "",
                                  },
                                }),
                                _c("div", { staticClass: "ml-3 flex-1" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex items-center justify-between",
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(item.spuType) +
                                            " " +
                                            _vm._s(
                                              _vm.isZh
                                                ? item.spuPlace
                                                : item.spuPlaceEn
                                            )
                                        ),
                                      ]),
                                      _c("span", [
                                        _vm._v(
                                          "RM " +
                                            _vm._s(_vm.formatToYuan(item.price))
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex items-center justify-between",
                                    },
                                    [
                                      _c("span", { staticClass: "mr-1" }, [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.isZh
                                                ? item.dayValue.name +
                                                    (item.dayValue.name > 1
                                                      ? _vm.$t("products.days")
                                                      : _vm.$t(
                                                          "products.day"
                                                        )) +
                                                    " " +
                                                    item.packageValue.name
                                                : item.dayValue.nameEn +
                                                    (item.dayValue.nameEn > 1
                                                      ? _vm.$t("products.days")
                                                      : _vm.$t(
                                                          "products.day"
                                                        )) +
                                                    " " +
                                                    item.packageValue.nameEn
                                            ) +
                                            " "
                                        ),
                                      ]),
                                      _c("span", [
                                        _vm._v("x" + _vm._s(item.count)),
                                      ]),
                                    ]
                                  ),
                                ]),
                              ]
                            )
                          }),
                        ],
                        2
                      )
                    }),
                    0
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.orders.length === 0
            ? _c("van-empty", {
                attrs: { description: _vm.$t("common.noData") },
              })
            : _vm._e(),
        ],
        1
      ),
      _c("van-dialog", {
        attrs: {
          title: _vm.$t("orders.confirmCancel"),
          "show-cancel-button": "",
          "confirm-button-text": _vm.$t("common.confirm"),
          "cancel-button-text": _vm.$t("common.cancel"),
        },
        on: { confirm: _vm.confirmCancel },
        model: {
          value: _vm.showCancelDialog,
          callback: function ($$v) {
            _vm.showCancelDialog = $$v
          },
          expression: "showCancelDialog",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }